import type { Language } from '@seek/melways-sites';

import { getWindowOpen } from '../../../utils/window';

export const navigateToUrl = (url = '', isNewWindow = false) => {
  if (url !== '') {
    const open = getWindowOpen();
    open(url, isNewWindow ? '_blank' : '_self');
  }
};

export const convertLocationsIntoCommaList = (
  nationalities: string[],
  language: Language,
): string | undefined => {
  if (nationalities.length === 0) {
    return undefined;
  }
  const sortedNationalities = nationalities.sort();
  const shortListFormatter = new Intl.ListFormat(language, {
    style: 'short',
    type: 'unit',
  });

  return shortListFormatter.format(sortedNationalities);
};
